import React from "react";
import { Dialog, Icon, Classes } from "@blueprintjs/core";
import style from "./index.module.scss";

const HistoryPopup = ({ setHistoryPop, historyData,historyHearderData }) => {
  const ActionButton = ({ text, className, onClick, disabled = false }) => (
    <button className={className} onClick={onClick} disabled={disabled}>
      {text}
    </button>
  );

  const getRawValue = (dataVal, key) =>
    dataVal?.recordRawData?.find((item) => item.key === key)?.value || "";

const formatDate = (dateString) => {
  if (!dateString) return "";

  let date;

  if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
    date = new Date(`${dateString}T00:00:00Z`);
  }
  else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dateString)) {
    date = new Date(dateString.replace(" ", "T") + "Z");
  }
  else {
    date = new Date(dateString);
  }

  if (isNaN(date.getTime())) return dateString;

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "America/Chicago"
  }).format(date);
};

  const generateTimelineSteps = (records) => {
    if (!records || records.length == 0) return [];

    const updatedRecord = records[0];
    const originalRecord = records[1] ? records[1] : records[0]; 

    const steps = [];

    const createdDate = formatDate(originalRecord?.createdDate || "");
    const createdBy = originalRecord?.user ? (originalRecord.user.name ? originalRecord.user.name.name : "") : "" || "";

    const modifiedDate = formatDate(updatedRecord?.lastModifiedDate || "");
    const modifiedBy = updatedRecord?.user ? (updatedRecord.user.name ? updatedRecord.user.name.name : "") : "" || "";

    const uploadedOn = formatDate(updatedRecord?.lastModifiedDate || "") ;
    const uploadedBy = updatedRecord?.user ? (updatedRecord.user.name ? updatedRecord.user.name.name : "") : "" || "";


    if (updatedRecord?.recordStatus === "MOVED_TO_DRAFT") {
      steps.push({
        isCenterBox: true,
        centerTitle: "New Record Moved To Draft",
        centerSub: modifiedDate,
      });
    }

    if ((updatedRecord?.recordStatus === "UPDATED_TO_ACTIVE" || updatedRecord?.recordStatus == "UPDATES_TO_EXPIRED") && modifiedDate) {
      steps.push({
        leftTitle: "Updated On",
        leftSub: modifiedDate,
        rightTitle: "Updated By",
        rightSub: modifiedBy,
      });
    }

    // Add upload step if available
    // if (uploadedOn && uploadedOn !== "NA") {
    //   steps.push({
    //     leftTitle: "Updated On",
    //     leftSub: uploadedOn,
    //     rightTitle: "Updated By",
    //     rightSub: uploadedBy,
    //   });
    // }

    if (originalRecord && createdDate) {
      steps.push({
        leftTitle: "Created On",
        leftSub: createdDate,
        rightTitle: "Created By",
        rightSub: createdBy,
      });
    }

    return steps;
  };

  const records = historyData && historyData.length > 0 ? historyData[0] : [];
  const activeRecord = records && records.length > 0 ? records[0] : null;

  if (!activeRecord) return null;

  const timelineSteps = generateTimelineSteps(records);

  return (
    <Dialog
      isOpen={true}
      onClose={() => setHistoryPop(false)}
      className={`${style.addManagerDialogBackground} ${style.mailTemplate}`}
    >
      <div className={Classes.DIALOG_BODY}>
        <div className={style.spaceBetween}>
          <h2 className={style.dialogTitle}>
            Update to Existing Contract from eCATS update
          </h2>
          <Icon
            icon="cross"
            className={style.crossStyle}
            onClick={() => setHistoryPop(false)}
          />
        </div>

        <div className={style.welcomeBorder}></div>

       
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            background: "#B3B8BD4D",
            padding: "10px",
            borderRadius: "4px",
          }}
        >
          <div>
            <p className={style.contractId} style={{ fontWeight: "700" }}>
              {historyHearderData ? (historyHearderData?.contractId ? historyHearderData?.contractId?.id : "") : "" || ''}
            </p>
            <p
              className={style.description}
              style={{ fontWeight: "700", marginBottom: 0 }}
            >
              {historyHearderData ? (historyHearderData?.contractName ? historyHearderData?.contractName?.contractName : "") : "" || ''}
            </p>
          </div>
          <div style={{ textAlign: "end" }}>
            <p>Last Processed Date: {formatDate(activeRecord.createdDate || '')}</p>
            <p style={{ marginBottom: 0 }}>
              Last Update Date: {formatDate(activeRecord.lastModifiedDate || '')}
            </p>
          </div>
        </div>

       
        <div className={style.timeline}>
          <div className={style.arrow}>↑</div>
          {timelineSteps.map((step, index, array) =>
            step.isCenterBox ? (
              <div className={style.iconCol2} key={index}>
                <div className={style.centerBox}>
                  <div>
                    <strong>{step.centerTitle}</strong>
                    <div>{step.centerSub}</div>
                  </div>
                </div>
                {index < array.length - 1 && (
                  <div className={style.vertLine}></div>
                )}
              </div>
            ) : (
              <div key={index} className={style.timelineRow}>
                <div className={style.left}>
                  <div className={style.title}>{step.leftTitle}</div>
                  <div className={style.sub}>{step.leftSub}</div>
                </div>
                <div className={style.iconCol}>
                  <div className={style.tickCircle}>
                    <Icon icon="tick" className={style.tickIcon} />
                  </div>
                  {index < array.length - 1 && (
                    <div className={style.vertLine}></div>
                  )}
                </div>
                <div className={style.right}>
                  <div className={style.title}>{step.rightTitle}</div>
                  <div className={style.sub}>{step.rightSub}</div>
                </div>
              </div>
            )
          )}
        </div>

      
        <div className={`${style.buttonContainer} ${style.marginTop20}`}>
          <ActionButton
            text="CANCEL"
            className={style.resetButton}
            onClick={() => setHistoryPop(false)}
          />
          <div className={style.rightButtons}>
            <ActionButton
              text="OKAY"
              className={style.saveButton}
              onClick={() => setHistoryPop(false)}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default HistoryPopup;